import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { CdkMenuTrigger, CdkMenu, CdkMenuItem } from "@angular/cdk/menu";
import {
  UIComponentsModule,
  CariButtonComponent,
} from "@cariloop/ui-components";
import { LanguageType } from "app/shared/types/language.type";
import { TranslateModule } from "@ngx-translate/core";
import { LANGUAGES } from "app/languages";
import { AccountService } from "app/shared/services/account.service";
import { AppTranslateService } from "app/shared/services/app-translate.service";
import { StorageService } from "app/shared/services/storage.service";

export type LanguageChangedData = {
  previousLanguage: LanguageType;
  newLanguage: LanguageType;
};

@Component({
  selector: "[lang-dropdown]",
  imports: [
    CommonModule,
    CdkMenuTrigger,
    CdkMenu,
    CdkMenuItem,
    UIComponentsModule,
    CariButtonComponent,
    TranslateModule,
  ],
  templateUrl: "./lang-dropdown.component.html",
  styleUrls: ["./lang-dropdown.component.scss"],
})
export class LangDropdownComponent implements OnInit {
  readonly #accountService = inject(AccountService);
  readonly #appTranslateService = inject(AppTranslateService);
  readonly #storageService = inject(StorageService);
  @Input() showIconOnlyMobile = false;
  @Output() onLanguageChanged = new EventEmitter<LanguageChangedData>();
  languages = LANGUAGES;
  fallbackLanguage: LanguageType = LANGUAGES[0];
  browserLanguage: LanguageType = this.fallbackLanguage;

  ngOnInit() {
    const localStorageLanguage = this.#storageService.getItem("language");
    if (!localStorageLanguage) {
      this.browserLanguage =
        LANGUAGES.find(
          ({ value }) => value === window.navigator.language.substring(0, 2),
        ) ?? LANGUAGES[0];
    } else {
      this.browserLanguage =
        LANGUAGES.find(({ value }) => value === localStorageLanguage?.value) ??
        LANGUAGES[0];
    }

    this.#appTranslateService.updateLang(this.browserLanguage.value);
  }

  changeLanguage(language: string) {
    const newLanguage =
      LANGUAGES.find(({ value }) => value === language) ??
      this.fallbackLanguage;
    const previousLanguage = this.browserLanguage;

    this.browserLanguage = newLanguage;

    this.#accountService.setLocalLanguage(newLanguage);

    this.#appTranslateService.updateLang(newLanguage.value);

    this.onLanguageChanged.emit({
      previousLanguage,
      newLanguage,
    });

    return newLanguage;
  }
}
